export const FIRM_DOCUMENT_FOLDER_ACTIONS_LABELS = {
  addSubfolder: 'Add Subfolder',
  delete: 'Delete',
  rename: 'Edit',
  trigger: (folderName: string) => `${folderName} folder actions`,
  uploadDocument: 'Upload Document',
} as const;
